const INTENT_STORAGE_KEY = 'fxq_intent_pending'
const CERT_STORAGE_KEY = 'fxq_cert_apply'

export const CERT_POLL_INTERVAL = 2500
export const CERT_POLL_TIMEOUT = 60000

const INTENT_FAIL_STATUS = ['FAIL', 'FAILED', 'REJECT', 'REJECTED', 'EXPIRED']

export function isIntentCompleted(status) {
    return status === 'COMPLETED' || status === 'USED'
}

export function authErrorMessage(code, message) {
    if (code === 10032) {
        return '证书申请异常，请稍后重试'
    }
    if (code === 10039) {
        return '服务提供商异常，请稍后重试'
    }
    return message || '请求失败，请稍后重试'
}

export function saveIntentPending(payload) {
    sessionStorage.setItem(INTENT_STORAGE_KEY, JSON.stringify(payload))
}

export function readIntentPending() {
    try {
        const raw = sessionStorage.getItem(INTENT_STORAGE_KEY)
        return raw ? JSON.parse(raw) : null
    } catch (error) {
        return null
    }
}

export function clearIntentPending() {
    sessionStorage.removeItem(INTENT_STORAGE_KEY)
}

export function saveCertApply(payload) {
    sessionStorage.setItem(CERT_STORAGE_KEY, JSON.stringify(payload))
}

export function readCertApply() {
    try {
        const raw = sessionStorage.getItem(CERT_STORAGE_KEY)
        return raw ? JSON.parse(raw) : null
    } catch (error) {
        return null
    }
}

export function clearCertApply() {
    sessionStorage.removeItem(CERT_STORAGE_KEY)
}

export function buildHashRedirect(hashPath) {
    const { origin, pathname } = window.location
    const path = hashPath.startsWith('/') ? hashPath : `/${hashPath}`
    return `${origin}${pathname}#${path}`
}

export function pickField(source, keys) {
    if (!source) {
        return ''
    }
    for (let i = 0; i < keys.length; i++) {
        const value = source[keys[i]]
        if (value !== undefined && value !== null && value !== '') {
            return value
        }
    }
    return ''
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

/**
 * 轮询接口，直到成功、失败或超时。
 * isDone / isFailed 接收整包响应 { code, message, data }
 */
export async function pollRequest(requestFn, options = {}) {
    const {
        interval = CERT_POLL_INTERVAL,
        timeout = CERT_POLL_TIMEOUT,
        isDone = () => false,
        isFailed = () => false,
        shouldStop = () => false
    } = options
    const start = Date.now()
    let last = null
    while (Date.now() - start <= timeout) {
        if (shouldStop()) {
            return { stopped: true, last }
        }
        try {
            last = await requestFn()
        } catch (error) {
            last = { error }
        }
        if (last && !last.error && isDone(last)) {
            return { done: true, last }
        }
        if (last && !last.error && isFailed(last)) {
            return { failed: true, last }
        }
        if (Date.now() - start >= timeout) {
            break
        }
        await sleep(interval)
    }
    return { timeout: true, last }
}

export function isIntentResultDone(res) {
    const body = (res && res.data) || {}
    return res && res.code === 200 && (body.completed === true || isIntentCompleted(body.status))
}

export function isIntentResultFailed(res) {
    if (!res) {
        return false
    }
    if (res.code === 10032 || res.code === 10039) {
        return true
    }
    const status = res.data && res.data.status
    return INTENT_FAIL_STATUS.indexOf(status) !== -1
}

export function isCertApplyDone(res) {
    const body = (res && res.data) || {}
    return res && res.code === 200 && (body.success === true || body.status === 'SUCCESS')
}

export function isCertApplyFailed(res) {
    if (!res) {
        return false
    }
    if (res.code === 10032 || res.code === 10039) {
        return true
    }
    const status = res.data && res.data.status
    return ['FAIL', 'FAILED', 'REJECT', 'REJECTED', 'EXPIRED'].indexOf(status) !== -1
}
